var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    { ref: "modal", attrs: { "overlay-theme": "dark" } },
    [
      _c("h3", [_vm._v("คำตอบที่ตอบผิด")]),
      _vm._v(" "),
      _vm._l(_vm.questionAnswers, function(item, index) {
        return _c("div", { key: index, staticClass: "text-left" }, [
          _c("h4", [
            _vm._v(_vm._s(index + 1) + ". " + _vm._s(item.question_text))
          ]),
          _vm._v(" "),
          item.question_image_url
            ? _c("div", [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: item.question_image_url, alt: "" }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticStyle: { margin: "2rem" } }, [
            _c(
              "div",
              {
                staticClass: "mb-2 d-flex",
                class: _vm.checkAnswer(
                  item,
                  item.question_answer_1_text,
                  item.question_answer_1_image_url
                )
              },
              [
                _c("div", { staticClass: "mr-3" }, [_vm._v("ก.")]),
                _vm._v(" "),
                _c("div", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.convertLineBreaks(item.question_answer_1_text)
                      )
                    }
                  }),
                  _vm._v(" "),
                  item.question_answer_1_image_url
                    ? _c("div", [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.question_answer_1_image_url,
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mb-2 d-flex",
                class: _vm.checkAnswer(
                  item,
                  item.question_answer_2_text,
                  item.question_answer_2_image_url
                )
              },
              [
                _c("div", { staticClass: "mr-3" }, [_vm._v("ข.")]),
                _vm._v(" "),
                _c("div", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.convertLineBreaks(item.question_answer_2_text)
                      )
                    }
                  }),
                  _vm._v(" "),
                  item.question_answer_2_image_url
                    ? _c("div", [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.question_answer_2_image_url,
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mb-2 d-flex",
                class: _vm.checkAnswer(
                  item,
                  item.question_answer_3_text,
                  item.question_answer_3_image_url
                )
              },
              [
                _c("div", { staticClass: "mr-3" }, [_vm._v("ค.")]),
                _vm._v(" "),
                _c("div", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.convertLineBreaks(item.question_answer_3_text)
                      )
                    }
                  }),
                  _vm._v(" "),
                  item.question_answer_3_image_url
                    ? _c("div", [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.question_answer_3_image_url,
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mb-2 d-flex",
                class: _vm.checkAnswer(
                  item,
                  item.question_answer_4_text,
                  item.question_answer_4_image_url
                )
              },
              [
                _c("div", { staticClass: "mr-3" }, [_vm._v("ง.")]),
                _vm._v(" "),
                _c("div", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.convertLineBreaks(item.question_answer_4_text)
                      )
                    }
                  }),
                  _vm._v(" "),
                  item.question_answer_4_image_url
                    ? _c("div", [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.question_answer_4_image_url,
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("hr")
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ba01cdd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba01cdd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/ExaminationModal.vue
// module id = 2158
// module chunks = 0